import Modal from "react-modal/lib/components/Modal";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import "./style.css";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import { IndexHook } from "./hook";
import LibMask from "../../../../util/mask";
import HeaderSimple from "../../../../components/header/simple";
import { BtnBack } from "../../../../components/button/button-back";

//tabs
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import libFloat from "../../../../util/libFloat";
import LoadingFull from "../../../../components/loading/loading-full";
import { useContext, useState } from "react";
import ModalRegisterCategory from "../../category/modal-register";
import { ContextGlobal } from "../../../../context";
import AbaKit from "../kit";
import UploadPhotoV1 from "../../../../components/uploading/uploadingPhoto";
import UploadPhotoV2 from "../../../../components/uploading/uploadingPhotoV2";

function ModalRegisterProduct(props) {
	const {
		//hooks
		handleOnSubmit,
		handleFieldBlur,
		handleInputChange,
		handleChangeTab,
		handleCategoryChange,
		handleStrtoFloatChange,
		fetchCategory,
		// executeSubmitForm,

		loading,
		urlfoto,
		id_produto,
		loadingF,
		// setLoadingF,
		isUpdatedImage,
		setIsUpdatedImage,

		//context
		isOpenModalRegister,
		handleCloseModalRegister,

		//useForm
		register,
		handleSubmit,
		handleOnError,
		setValue,

		//formState
		errors,
		isSubmitting,

		//data
		categoryData,

		//tab
		valueTab,

		//grade
		isPaiGrade,
		isFilhoGrade,
	} = IndexHook();

	const { enterpriseData } = useContext(ContextGlobal);
	const mostrarKit = enterpriseData?.id_empresa === 1;

	const handleOpenUploadComponent = (e) => {
		e.preventDefault();

		const event = new CustomEvent("imgProduct");
		window.dispatchEvent(event);
	};

	const [isOpenModalCategory, setIsOpenModalCategory] = useState(false);

	// quando fecha o cadastro de uma nova categoria
	const handleCloseRegisterCategory = () => {
		setIsOpenModalCategory(false);
		fetchCategory();
	};

	const handleOpenRegisterCategory = (e) => {
		e.preventDefault();
		setIsOpenModalCategory(true);
	};

	const onChangeUploadProduct = (data) => {
		setValue("urlfoto", data.url);
	};

	return (
		<>
			{isOpenModalCategory ? (
				<ModalRegisterCategory
					id_tipoproduto={0}
					isOpenModalRegister={isOpenModalCategory}
					handleCloseModalRegister={handleCloseRegisterCategory}
					// setCategoryData={setCategoryData}
					// categoryData={categoryData}
				/>
			) : (
				<Modal
					isOpen={isOpenModalRegister}
					onRequestClose={handleCloseModalRegister}
					overlayClassName="react-modal-overlay"
					className="modal-content-form modal-product-resize"
					shouldCloseOnOverlayClick={false}
				>
					<div className="container-forms">
						<header className="">
							<HeaderSimple
								title="Cadastro de produtos"
								handleCloseModalRegister={handleCloseModalRegister}
							/>
						</header>
						{loadingF && <LoadingFull mensagem="Aguarde salvando cadastro" />}

						{loading ? (
							<div className="flex h-full">
								<Loading mensagem="Aguarde buscando dados no servidor..." />
							</div>
						) : (
							<form className="form" onSubmit={handleSubmit(handleOnSubmit, handleOnError)}>
								<TabContext value={valueTab} className="">
									<Box
										sx={{
											borderBottom: 1,
											borderColor: "divider",
										}}
									>
										<TabList
											onChange={handleChangeTab}
											aria-label="lab API tabs example"
											variant="scrollable"
											scrollButtons="auto"
											allowScrollButtonsMobile
										>
											<Tab
												label="Descrição"
												value="0"
												sx={{
													fontSize: "0.775rem",
												}}
											/>
											<Tab
												label="Estoque e valor"
												value="1"
												sx={{
													fontSize: "0.775rem",
												}}
											/>
											<Tab
												label="Dimensões e peso"
												value="2"
												sx={{
													fontSize: "0.775rem",
												}}
											/>
											<Tab
												label="Foto / Descrição"
												value="3"
												sx={{
													fontSize: "0.775rem",
												}}
											/>
											{mostrarKit && (
												<Tab
													label="Composição"
													value="4"
													sx={{
														fontSize: "0.775rem",
													}}
												/>
											)}
											{/* <Tab
												label="Ativo"
												value="4"
												sx={{
													fontSize: "0.775rem",
												}}
											/> */}
											{/* <Tab label="Complementos" value="3" /> */}
										</TabList>
									</Box>
									<main>
										<TabPanel value="0">
											<div className="row">
												<div className={`col-12 col-sm-8 col-lg-8 input-box `}>
													<label htmlFor="nome">Nome do produto</label>
													<input //
														className={`${errors.nome ? "error" : ""}`}
														id="nome"
														{...register("nome")}
														type="text"
														placeholder="Nome do produto"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
														autoFocus
													/>
													{errors.nome && <p className="errors">{errors.nome.message}</p>}
												</div>

												<div className={`col-12 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="ean">Ean / Código produto</label>
													<input //
														className={`${errors.ean ? "error" : ""}`}
														id="ean"
														{...register("ean")}
														type="text"
														placeholder="Ean"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.ean && <p className="errors">{errors.ean.message}</p>}
												</div>

												<div className={`col-8 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="referencia">Referência</label>
													<input //
														className={`${errors.referencia ? "error" : ""}`}
														id="referencia"
														{...register("referencia")}
														type="text"
														placeholder="Referência"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.referencia && (
														<p className="errors">{errors.referencia.message}</p>
													)}
												</div>

												<div className={`col-4 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="und">UND</label>
													<input //
														className={`${errors.und ? "error" : ""}`}
														id="und"
														{...register("und")}
														type="text"
														placeholder="unidade de medida"
														onChange={(e) => {
															handleInputChange(e);
														}}
														onKeyDown={(e) => libForm.EnterTab(e)}
														autoComplete="off"
													/>
													{errors.und && <p className="errors">{errors.und.message}</p>}
												</div>

												<div className="input-select-box d-flex flex-column col-12 col-sm-4 col-lg-4">
													<label htmlFor="id_tipoproduto">Categoria</label>
													<select
														{...register("id_tipoproduto", {
															setValueAs: (value) => parseInt(value, 10),
														})}
														defaultValue=""
														onChange={(e) => {
															handleCategoryChange(e);
															register("id_tipoproduto").onChange(e);
														}}
														onKeyDown={(e) => {
															if (e.key === "Enter") handleChangeTab(e, "1");
														}}
													>
														<option value="" disabled>
															Selecione uma categoria
														</option>
														{categoryData?.map((category) => (
															<option
																key={category.id_tipoproduto}
																value={category.id_tipoproduto}
															>
																{category.nome}
															</option>
														))}
													</select>
													{errors.id_tipoproduto && <p>{errors.id_tipoproduto.message}</p>}
													<div className="flex h-4 justify-end">
														<button
															className="flex btn btn-success items-center text-xs"
															onClick={(e) => handleOpenRegisterCategory(e)}
														>
															Cadastrar Categoria
														</button>
													</div>
												</div>

												<div className="col-12 flex gap-2 mt-2">
													<input id="balanca" type="checkbox" {...register("balanca")} />
													<label htmlFor="balanca">
														<span className="text-sm">Produto etiqueta balança</span>
													</label>
												</div>
											</div>
										</TabPanel>
										<TabPanel value="1">
											<div className="row">
												{(isPaiGrade || isFilhoGrade) && (
													<div className="col-12 mb-3">
														<div className="flex items-center gap-2 rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm text-blue-700">
															<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
																<path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
															</svg>
															{isFilhoGrade
																? "Produto filho de grade — estoque, valor de venda e valor promocional são gerenciados pela tela de Grade."
																: "Produto pai de grade — o estoque é gerenciado pela tela de Grade."}
														</div>
													</div>
												)}
												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="qtatual">Estoque</label>
													<input //
														className={`${errors.qtatual ? "error" : ""} ${(isPaiGrade || isFilhoGrade) ? "opacity-50 cursor-not-allowed" : ""}`}
														id="qtatual"
														{...register("qtatual")}
														type="text"
														placeholder="Estoque"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onFocus={(e) => e.target.select()}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
														disabled={isPaiGrade || isFilhoGrade}
													/>
													{errors.qtatual && (
														<p className="errors">{errors.qtatual.message}</p>
													)}
												</div>
												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="valor">Valor de venda</label>
													<input //
														className={`${errors.valor ? "error" : ""} ${isFilhoGrade ? "opacity-50 cursor-not-allowed" : ""}`}
														id="valor"
														{...register("valor")}
														type="text"
														placeholder="Valor do produto"
														onFocus={(e) => e.target.select()}
														onBlur={(e) => handleFieldBlur(e, "valor")}
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
														autoComplete="off"
														disabled={isFilhoGrade}
													/>
													{errors.valor && <p className="errors">{errors.valor.message}</p>}
												</div>
												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label
														htmlFor="valorpromoapi"
														className="truncate w-[150px] lg:w-auto lg:overflow-hidden lg:whitespace-normal"
													>
														Valor promocional catálogo on-line
													</label>
													<input //
														className={`${errors.valorpromoapi ? "error" : ""} ${isFilhoGrade ? "opacity-50 cursor-not-allowed" : ""}`}
														id="valorpromoapi"
														{...register("valorpromoapi")}
														type="text"
														placeholder="valorpromoapi do produto"
														onFocus={(e) => e.target.select()}
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
														autoComplete="off"
														disabled={isFilhoGrade}
													/>
													{errors.valorpromoapi && (
														<p className="errors">{errors.valorpromoapi.message}</p>
													)}
												</div>

												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="qtcritica">Quantidade crítica</label>
													<input //
														className={`${errors.qtcritica ? "error" : ""}`}
														id="qtcritica"
														{...register("qtcritica")}
														type="text"
														placeholder="Crítica"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onFocus={(e) => e.target.select()}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.qtcritica && (
														<p className="errors">{errors.qtcritica.message}</p>
													)}
												</div>

												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="custo">Valor Pago</label>
													<input //
														className={`${errors.custo ? "error" : ""}`}
														id="custo"
														{...register("custo")}
														type="text"
														placeholder="Valor Pago"
														onBlur={() => handleFieldBlur("custo")}
														onFocus={(e) => e.target.select()}
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
													/>
													{errors.custo && <p className="errors">{errors.custo.message}</p>}
												</div>
												{/* 
												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="rendimento">Rendimento %</label>
													<input //
														className={`${errors.rendimento ? "error" : ""}`}
														id="rendimento"
														{...register("rendimento")}
														type="text"
														placeholder="Rendimento"
														onBlur={() => handleFieldBlur("rendimento")}
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
														autoComplete="off"
													/>
													{errors.rendimento && (
														<p className="errors">{errors.rendimento.message}</p>
													)}
												</div> */}

												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="lucro">Custo</label>
													<input //
														className={`${errors.lucro ? "error" : ""}`}
														id="lucro"
														{...register("lucro")}
														type="text"
														placeholder="Custo"
														onBlur={() => handleFieldBlur("lucro")}
														onFocus={(e) => e.target.select()}
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
														autoComplete="off"
													/>
													{errors.lucro && <p className="errors">{errors.lucro.message}</p>}
												</div>

												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="markup">Markup</label>
													<input //
														className={`${errors.markup ? "error" : ""}`}
														id="markup"
														{...register("markup")}
														type="text"
														placeholder="markup"
														onBlur={() => handleFieldBlur("markup")}
														onFocus={(e) => e.target.select()}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
														onKeyDown={(e) => libForm.EnterTab(e)}
														autoComplete="off"
													/>
													{errors.markup && <p className="errors">{errors.markup.message}</p>}
												</div>
												<div className={`col-6 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="comissao">Comissão</label>
													<input //
														className={`${errors.markup ? "error" : ""}`}
														id="comissao"
														{...register("comissao")}
														type="text"
														placeholder="comissao"
														onBlur={() => handleFieldBlur("comissao")}
														onFocus={(e) => e.target.select()}
														onChange={(e) => {
															handleStrtoFloatChange(e);
														}}
														onKeyDown={(e) => {
															if (e.key === "Enter") handleChangeTab(e, "2");
														}}
														autoComplete="off"
													/>
													{errors.comissao && (
														<p className="errors">{errors.comissao.message}</p>
													)}
												</div>
											</div>
										</TabPanel>
										<TabPanel value="2">
											<div className="row">
												<div className={`col-8 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="referencia">Largura em cm</label>
													<input //
														className={`${errors.largura ? "error" : ""}`}
														id="largura"
														{...register("largura")}
														type="text"
														placeholder="Largura em cm"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.largura && (
														<p className="errors">{errors.largura.message}</p>
													)}
												</div>
												<div className={`col-8 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="referencia">Comprimento em cm</label>
													<input //
														className={`${errors.comprimento ? "error" : ""}`}
														id="comprimento"
														{...register("comprimento")}
														type="text"
														placeholder="Comprimento em cm"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.comprimento && (
														<p className="errors">{errors.comprimento.message}</p>
													)}
												</div>
												<div className={`col-8 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="referencia">Altura em cm</label>
													<input //
														className={`${errors.altura ? "error" : ""}`}
														id="altura"
														{...register("altura")}
														type="text"
														placeholder="Altura em cm"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.altura && <p className="errors">{errors.altura.message}</p>}
												</div>
												<div className={`col-8 col-sm-4 col-lg-4 input-box `}>
													<label htmlFor="referencia">Peso em gramas</label>
													<input //
														className={`${errors.pesobruto ? "error" : ""}`}
														id="pesobruto"
														{...register("pesobruto")}
														type="text"
														placeholder="Peso em gramas"
														onKeyDown={(e) => libForm.EnterTab(e)}
														onChange={(e) => {
															handleInputChange(e);
														}}
														autoComplete="off"
													/>
													{errors.pesobruto && (
														<p className="errors">{errors.pesobruto.message}</p>
													)}
												</div>
												<div className={`check-box col-12 col-sm-4`}>
													<div className="check-input">
														<input
															className={`${errors.fragil ? "error" : ""}`}
															id="fragil"
															type="checkbox"
															{...register("fragil")}
															onKeyDown={(e) => libForm.EnterTab(e)}
															autoComplete="off"
														/>
														<label htmlFor="fragil">
															<span className="text-lg">Frágil</span>
														</label>
													</div>
												</div>
												<div className={`check-box col-12 col-sm-4`}>
													<div className="check-input">
														<input
															className={`${errors.caixa_propria ? "error" : ""}`}
															id="caixa_propria"
															type="checkbox"
															{...register("caixa_propria")}
															onKeyDown={(e) => {
																if (e.key === "Enter") handleChangeTab(e, "3");
															}}
															autoComplete="off"
														/>
														<label htmlFor="caixa_propria">
															<span className="text-lg">Caixa Própria</span>
														</label>
													</div>
												</div>
											</div>
										</TabPanel>
										<TabPanel value="3">
											<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
												<div>
													<div className="relative h-72 rounded-lg overflow-hidden">
														<img
															src={urlfoto}
															alt=""
															className="absolute inset-0 w-full h-full object-contain rounded-lg shadow-lg"
														/>
													</div>

													<button
														className="btn btn-sm btn-outline-primary mt-3 w-full"
														onClick={handleOpenUploadComponent}
													>
														Escolher imagem
													</button>

													{isUpdatedImage && (
														<span className="flex text-red-500 text-bold w-full justify-center">
															Clique em salvar para aplicar foto ao produto
														</span>
													)}
												</div>
												<div>
													<div className="">
														<label htmlFor="descricaoapi">Descrição</label>
														<textarea
															type="text"
															className={`form-control ${
																errors.descricaoapi ? "is-invalid" : ""
															} h-40`}
															id="descricaoapi"
															name="descricaoapi"
															placeholder="Insira a descrição do produto" //
															{...register("descricaoapi")}
															onChange={(e) => {
																handleInputChange(e);
															}}
														/>

														{errors.descricaoapi && (
															<p className="text-danger">{errors.descricaoapi.message}</p>
														)}
													</div>
													<div className="p-3">
														<div className="flex gap-2">
															<input
																className={`${errors.ativo ? "error" : ""}`}
																id="ativo"
																type="checkbox"
																{...register("ativo")}
															/>
															<label htmlFor="ativo">
																<span className="font-semibold">
																	Produto ativo no PDV
																</span>
															</label>
														</div>
														<div className="flex gap-2">
															<input
																className={`${errors.ativoapi ? "error" : ""}`}
																id="ativoapi"
																type="checkbox"
																{...register("ativoapi")}
															/>
															<label htmlFor="ativoapi">
																<span className="font-semibold">
																	Produto ativo no catálogo on-line
																</span>
															</label>
														</div>
														<div className="flex gap-2">
															<input
																className={`${errors.ativoapi ? "error" : ""}`}
																id="destaque"
																type="checkbox"
																{...register("destaque")}
															/>
															<label htmlFor="destaque">
																<span className="text-sm">
																	Destacar produto no catálogo on-line
																</span>
															</label>
														</div>
														<div className="flex gap-2">
															<input
																className={`${errors.ativoapi ? "error" : ""}`}
																id="mais_pedidos"
																type="checkbox"
																{...register("mais_pedidos")}
															/>
															<label htmlFor="mais_pedidos">
																<span className="text-sm">
																	Mostrar produto como mais pedido
																</span>
															</label>
														</div>
													</div>
												</div>
											</div>
										</TabPanel>

										{mostrarKit && (
											<TabPanel value="4">
												<AbaKit idProduto={id_produto} />
											</TabPanel>
										)}

										{/* <TabPanel value="4">
											<div className="row">
												<div className={`check-box col-12 col-sm-12`}>
													<div className="check-input">
														<input
															className={`${errors.ativo ? "error" : ""}`}
															id="ativo"
															type="checkbox"
															{...register("ativo")}
															onKeyDown={(e) => libForm.EnterTab(e)}
															autoComplete="off"
														/>
														<label htmlFor="ativo">
															<span className="text-lg">Produto ativo no pdv</span>
														</label>
													</div>
												</div>
											</div>
										</TabPanel> */}
									</main>
								</TabContext>

								<footer>
									<BtnBack onClick={handleCloseModalRegister} isSubmitting={isSubmitting} />
									<BtnSubmit isSubmitting={isSubmitting} />
								</footer>
							</form>
						)}
					</div>
					<UploadPhotoV2
						ident="imgProduct"
						nameImg="product"
						id={id_produto}
						onChange={onChangeUploadProduct}
					/>
				</Modal>
			)}
		</>
	);
}

export default ModalRegisterProduct;
